module.exports = __webpack_public_path__ + "img/img-6.5576c855.png";